import { generatePath } from "@routes/utils";
import { refresh } from "@api/auth/token/refresh/path";
import { twoFa } from "@api/auth/token/twoFa/path";

const pathBase = `/auth/token/`;

export const token = {
  post: () => generatePath(pathBase, null),
  refresh,
  twoFa,
};
